import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { VacationAddPage } from '../vacation-add/vacation-add';
import { VacationDetailsPage } from '../vacation-details/vacation-details';

import * as moment from 'moment';
import 'moment/locale/de';

/**
 * Generated class for the VacationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-vacation',
  templateUrl: 'vacation.html',
})
export class VacationPage {
  title: string = 'Urlaubsanträge';

  showCounter: boolean = false;

  currentDays: number = 15;
  allDays: number = 26;

  vacations: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider,  public teamappProvider: TeamappProvider, public modalCtrl: ModalController) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VacationPage');
  }


  ionViewDidEnter() {
      this.loadVacations();
  }

  onCircleRender(value: any) {
    if(value == this.currentDays) {

    }
  }

  openVacationDetails(vacation: any) {
    let vacationModal = this.modalCtrl.create(VacationDetailsPage, { vacation });
    vacationModal.onDidDismiss(() => {
        this.loadVacations();
    });
    vacationModal.present();
  }

  loadVacations() {
    this.teamappProvider.http_request('action=get_vacation', 'vacation', false).then(data => {
      this.vacations = data;
      console.log(this.vacations);
    });
  }

  formatDate(date: any) {
    return moment(date).format("DD.MM.YYYY");
  }

  openAddVacationPage() {
    this.navCtrl.push(VacationAddPage);
  }

  refreshVacations(event: any) {
    this.loadVacations();
    event.complete();
  }

}



// WEBPACK FOOTER //
// ./src/pages/vacation/vacation.ts